import { HttpClient, HttpErrorResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { catchError, Observable, throwError } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private http = inject(HttpClient)

  // Set by `init()` at application startup
  private cognitoClientId?: string
  private cognitoDomain?: string
  private apiUrl?: string

  public init(cognitoDomain: string, cognitoClientId: string, apiUrl: string) {
    this.cognitoDomain = cognitoDomain
    this.cognitoClientId = cognitoClientId
    this.apiUrl = apiUrl
  }

  public getApiUrl() {
    return this.apiUrl
  }

  public redirectToLogin() {
    // Clean local data
    indexedDB.deleteDatabase('agronne-store')
    localStorage.clear()
    sessionStorage.clear()
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => registration.unregister())
    })
    const loginUrl: string = `${this.cognitoDomain}/login?response_type=code&client_id=${
      this.cognitoClientId
    }&redirect_uri=${this.apiUrl}/auth/callback&state=${window.location.hostname.split('.')[0]}`
    window.location.href = loginUrl
  }

  public refreshTokens(): Observable<unknown> {
    return this.http.get(`${this.apiUrl}/auth/refresh`).pipe(
      catchError((error: HttpErrorResponse) => {
        this.redirectToLogin()
        const err: Error = new Error(String(error))
        return throwError(() => err)
      }),
    )
  }
}
